import React, { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

import urls, { getCsrfToken } from '../com.zedock.common.script/urls.js';
import { clicks } from '../com.zedock.common.script/common.js';

import '../com.zedock.common.style/ContactUs.css';
import '../com.zedock.common.style/common.css';

function ContactUs() {

  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    clicks(location.pathname);
    window.scrollTo({ top: 0, behavior: 'instant' });
  }, []);
  return (


    <div className="container px-0    ">

            <div className="zd-wrap p-2 p-lg-4">

        <div className="row  ">
          <nav aria-label="breadcrumb" className="zd-crumb">
            <ol className="breadcrumb mb-0">
              <li className="breadcrumb-item">
                <a href="" onClick={(e) => { e.preventDefault(); navigate("/Product") }}>Home</a>
              </li>
              <li className="breadcrumb-item active" aria-current="page">Contact Us</li>
            </ol>
          </nav>
        </div>

        <div className="zd-page-head">
          <span className="zd-page-eyebrow">We're here to help</span>
          <h2>Contact Zedock</h2>
        </div>

        {/* ---------------- trust strip ---------------- */}
        <div className="row  g-2 mb-2">
          <div className="col-12">
            <div className="zd-trust-strip row g-0 text-center">
              <div className="col-6 col-lg-2 mx-auto zd-trust-item">
                <div className="zd-trust-icon">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
                    <rect x="2" y="6" width="20" height="14" rx="2"></rect><path d="M2 10h20"></path><path d="M6 15h4"></path>
                  </svg>
                </div>
                <h6>Cash on Delivery</h6>
              </div>
              <div className="col-6 col-lg-2 mx-auto zd-trust-item">
                <div className="zd-trust-icon">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M12 2l8 4v6c0 5-3.4 8.4-8 10-4.6-1.6-8-5-8-10V6l8-4z"></path><path d="M9 12l2 2 4-4"></path>
                  </svg>
                </div>
                <h6>Genuine Product</h6>
              </div>
              <div className="col-6 col-lg-2 mx-auto zd-trust-item">
                <div className="zd-trust-icon">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
                    <rect x="1" y="7" width="15" height="10" rx="1"></rect><path d="M16 10h4l3 3v4h-7z"></path>
                    <circle cx="6" cy="19" r="1.6"></circle><circle cx="18" cy="19" r="1.6"></circle>
                  </svg>
                </div>
                <h6>Fast Delivery</h6>
              </div>
              <div className="col-6 col-lg-2 mx-auto zd-trust-item">
                <div className="zd-trust-icon">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M12 22s7-6.1 7-12a7 7 0 1 0-14 0c0 5.9 7 12 7 12z"></path><circle cx="12" cy="10" r="2.4"></circle>
                  </svg>
                </div>
                <h6>PAN India</h6>
              </div>
              <div className="col-6 col-lg-2 mx-auto zd-trust-item">
                <div className="zd-trust-icon">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
                    <polyline points="1 4 1 10 7 10"></polyline><path d="M3.5 15a9 9 0 1 0 1.6-9.4L1 10"></path>
                  </svg>
                </div>
                <h6>Easy Return</h6>
              </div>
            </div>
          </div>
        </div>

        {/* ---------------- contact info + map ---------------- */}
        <div className="row g-2 mb-2">
          <div className="col-12">
            <div className="zd-contact-panel row g-0">

              <div className="col-lg-6 col-12">
                <div className="zd-contact-info">
                  <span className="zd-contact-eyebrow">Get in touch</span>
                  <h2>Contact Us</h2>
                  <p>We're here to help with product inquiries, support requests, or general questions. Reach out anytime!</p>

                  <div className="zd-contact-row">
                    <div className="zd-contact-icon">
                      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
                        <rect x="2" y="4" width="20" height="16" rx="2"></rect><path d="M2 7l10 6 10-6"></path>
                      </svg>
                    </div>
                    <span>support@zedock.com</span>
                  </div>

                  <div className="zd-contact-row">
                    <div className="zd-contact-icon">
                      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
                        <path d="M22 16.9v3a2 2 0 0 1-2.2 2 19.8 19.8 0 0 1-8.6-3.1 19.5 19.5 0 0 1-6-6 19.8 19.8 0 0 1-3.1-8.7A2 2 0 0 1 4.1 2h3a2 2 0 0 1 2 1.7c.1.9.3 1.8.6 2.7a2 2 0 0 1-.5 2.1L8 9.6a16 16 0 0 0 6 6l1.1-1.2a2 2 0 0 1 2.1-.5c.9.3 1.8.5 2.7.6a2 2 0 0 1 1.1 2z"></path>
                      </svg>
                    </div>
                    <a href="tel:7619311073">+91 76193 11073</a>
                  </div>
                </div>
              </div>

              <div className="col-lg-6 col-12">
                <div className="zd-map-wrap ratio ratio-16x9 h-100">
                  <iframe
                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3916.123456789!2d77.5946!3d12.9716!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bae167123456789%3A0xabcdef123456789!2sBengaluru%2C%20India!5e0!3m2!1sen!2sin!4v1637512439384!5m2!1sen!2sin"
                    width="100%"
                    height="100%"
                    style={{ border: 0 }}
                    allowFullScreen=""
                    loading="lazy"
                    referrerPolicy="no-referrer-when-downgrade"
                    title="Zedock Location"
                  ></iframe>
                </div>
              </div>

            </div>
          </div>
        </div>

        {/* ---------------- FAQ cards ---------------- */}
        <div className="row  g-2 mb-2">
          <div className="col-12 col-lg-4">
            <div className="zd-faq-card">
              <h3>How do I receive a refund for a returned product?</h3>
              <p>We refund the amount after the product has been received by our warehouse and post completion of quality check. This entire process takes 1-2 weeks after the return has been picked up.</p>
            </div>
          </div>
          <div className="col-12 col-lg-4">
            <div className="zd-faq-card">
              <h3>Do I need to pay for shipping?</h3>
              <p>A small ₹50 shipping charge applies to any order, plus ₹30 for Cash on Delivery orders — this keeps our courier partners reliable and secure at every touchpoint.</p>
            </div>
          </div>
          <div className="col-12 col-lg-4">
            <div className="zd-faq-card">
              <h3>When will I receive my order?</h3>
              <p>Delivery is handled through our fulfilment partners for timely, accurate service. Depending on your location, expect your order within 5 to 7 days.</p>
            </div>
          </div>
        </div>

        {/* ---------------- support tabs ---------------- */}
        <div className="row g-2   mb-2">
          <div className="col-12">
            <div className="zd-support-panel">
              <div className="d-flex align-items-start flex-column flex-md-row">
                <div className="nav flex-column nav-pills zd-pills" id="v-pills-tab" role="tablist" aria-orientation="vertical">
                  <button className="nav-link active" id="v-pills-home-tab" data-bs-toggle="pill" data-bs-target="#v-pills-home" type="button" role="tab" aria-controls="v-pills-home" aria-selected="true">Email</button>
                  <button className="nav-link" id="v-pills-profile-tab" data-bs-toggle="pill" data-bs-target="#v-pills-profile" type="button" role="tab" aria-controls="v-pills-profile" aria-selected="false">Phone</button>
                  <button className="nav-link" id="v-pills-messages-tab" data-bs-toggle="pill" data-bs-target="#v-pills-messages" type="button" role="tab" aria-controls="v-pills-messages" aria-selected="false">About us</button>
                </div>
                <div className="tab-content zd-tab-content" id="v-pills-tabContent">
                  <div className="tab-pane fade show active" id="v-pills-home" role="tabpanel" aria-labelledby="v-pills-home-tab" tabIndex="0">
                    <p>At Zedock, we value your time and strive to provide quick, reliable support. If you have questions about your orders, products, or services, please reach out to us at support@zedock.com. Our dedicated team monitors this inbox daily to ensure that your concerns are addressed promptly. Whether you need help with technical issues, billing inquiries, or general guidance, we are here to assist you. Sending us an email is the fastest way to get detailed responses and documentation. We aim to reply within 24 hours, ensuring you always feel supported and connected with Zedock.</p>
                  </div>
                  <div className="tab-pane fade" id="v-pills-profile" role="tabpanel" aria-labelledby="v-pills-profile-tab" tabIndex="0">
                    <p>Sometimes, speaking directly is the best way to resolve an issue. That's why Zedock offers phone support at +91 76193 11073. Our customer care representatives are trained to handle queries ranging from product details to troubleshooting and order tracking. By calling us, you'll receive personalized assistance and immediate solutions tailored to your needs. We believe in building trust through conversation, and our team is committed to listening carefully and resolving concerns efficiently. Whether you're a new customer or a long-time partner, Zedock's phone support ensures you always have someone ready to help.</p>
                  </div>
                  <div className="tab-pane fade" id="v-pills-messages" role="tabpanel" aria-labelledby="v-pills-messages-tab" tabIndex="0">
                    <p>Zedock is more than just a store — it's a commitment to quality, innovation, and customer satisfaction. Founded with the vision of simplifying online shopping, we bring together a wide range of products backed by reliable service. Our team works tirelessly to ensure that every interaction reflects our values of transparency, trust, and excellence. At Zedock, we believe in creating meaningful connections with our customers by offering not only products but also guidance and support. With a blend of modern technology and human care, Zedock continues to grow as a trusted name in e-commerce.</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>


    </div>
  );
}

export default ContactUs;
